import { ICurrencyData } from '@/models';
import { ICurrencyService } from './currency.types';
import { AxiosInstance } from 'axios';

export class CurrencyService implements ICurrencyService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/currencies/';
  }

  fetchCurrencies(): Promise<ICurrencyData[]> {
    return this.axios
      .get<ICurrencyData[]>(`${this.endpoint}`)
      .then(({ data }) => data);
  }

  fetchCurrency(id: number): Promise<ICurrencyData> {
    return this.axios
      .get<ICurrencyData>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createCurrency(data: ICurrencyData): Promise<ICurrencyData> {
    return this.axios
      .post<ICurrencyData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateCurrency(data: ICurrencyData): Promise<ICurrencyData> {
    return this.axios
      .patch<ICurrencyData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteCurrency(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }
}
